import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SoftAurora from '../../components/SoftAurora/SoftAurora';
import { Helmet } from "react-helmet";
import { TypeAnimation } from 'react-type-animation';
import ColorBends from '../../components/ColorBends/ColorBends';
import './home.css';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { FaWheelchair } from "react-icons/fa6";
import { BsFillPlayFill, BsBrush, BsSearch, BsEmojiLaughing, BsBracesAsterisk, BsCodeSlash, BsPhone, BsDatabase, BsClouds, BsCart4, BsPcDisplayHorizontal, BsPersonWorkspace, BsCpu, BsShieldCheck, BsLightningChargeFill, BsChatDots, BsGraphUp } from "react-icons/bs";
import { FaBrain } from "react-icons/fa6";
import { MdOutlineTrackChanges, MdOutlineRemoveRedEye, MdOutlineHandshake } from "react-icons/md";
import { RiRobot2Line } from "react-icons/ri";
import Componcontact from '../../components/Contact/contact-compon';
import project from './project.json';
import Testimonial from '../../components/Clienttestimonial/testimonial';
import Preloader from '../../components/Preloder/preloder';
import Clientlogo from '../../components/Clientlogo/clientlogo.json';
import Clientlogo2 from '../../components/Clientlogo/clientlogo2.json';
import Boxcard from '../../components/Cardesection/boxcard';
import Clientlogos from '../../components/Clientlogo/clientlogos';
import Rightlogo from '../../components/Clientlogo/rightlogo';
// import Animction from './animction';
import Particlesanimation from '../../components/Particlesanimation/particlesanimation';
import BanneremailIN from '../../components/BanneremailInput/banneremailIN';
import BanneremailAU from '../../components/BanneremailInput/BanneremailAu';
import BanneremailUS from '../../components/BanneremailInput/banneremailUS';
import { BiLeftArrow } from 'react-icons/bi';
// import Particlesanimation from '../../components/Particlesanimation/particlesanimation';





function Home() {
    const [userCountry, setUserCountry] = useState(null);
    const [activePanel, setActivePanel] = useState(project[0]?.id ?? 1);
    const apiToken = process.env.REACT_APP_API_TOKEN;

    useEffect(() => {
        axios
            .get(`https://ipinfo.io?token=${apiToken}`)
            .then((response) => {
                const data = response.data;
                const detectedCountry = data.country;
                setUserCountry(detectedCountry);
            })
            .catch((error) => {
                console.error('Error fetching user IP information', error);
            });
    }, []);

    // Determine the header component based on the user's country
    let BannerEmail;
    if (userCountry === 'IN') {
        BannerEmail = <BanneremailIN />;
    } else if (userCountry === 'US') {
        BannerEmail = <BanneremailUS />;
    } else if (userCountry === 'AU') {
        BannerEmail = <BanneremailAU />;
    } else {
        // Default header for other countries
        BannerEmail = <BanneremailIN />;
    }

    // Conditionally render social media links
    const socialMediaLinks = userCountry === 'US' ? (
        <div className="tp-banner-social d-none d-lg-block" style={{ left: '0%' }}>
            <a href="https://www.instagram.com/dgiworx/" target="_blank">INSTAGRAM</a>
            {/* <a href="https://www.instagram.com/dgiworx/" target="_blank">INSTAGRAM</a>
      <a href="https://www.instagram.com/dgiworx/" target="_blank">INSTAGRAM</a> */}
        </div>
    ) : (
        <div className="tp-banner-social d-none d-lg-block">
            <a href="https://www.instagram.com/dgiworx/" target="_blank">INSTAGRAM</a>
            <a href="https://www.behance.net/dgiworx" target="_blank">BEHANCE</a>
            <a href="https://www.facebook.com/dgiworx" target="_blank">FACEBOOK</a>
        </div>
    );
    // const [isLoading, setLoading] = useState(true);

    // useEffect(() => {
    //     setTimeout(() => {
    //         setLoading(false);
    //     }, 3000);
    // }, []);

    // service section
    const service = [
        {
            icons: BsCpu,
            title: "Generative AI & LLM Apps",
            description: "Custom GPT-class apps, copilots, and assistants tuned to your domain and private data."
        },
        {
            icons: RiRobot2Line,
            title: "AI Agents & Automation",
            description: "Autonomous, multi-step agents that orchestrate tasks across your existing tools and APIs."
        },
        {
            icons: BsDatabase,
            title: "RAG & Knowledge Systems",
            description: "Retrieval-augmented systems that ground AI answers in your private knowledge base."
        },
        {
            icons: MdOutlineRemoveRedEye,
            title: "Computer Vision",
            description: "Vision models for inspection, OCR, recognition, and visual analytics in production."
        },
        {
            icons: BsChatDots,
            title: "NLP & Conversational AI",
            description: "Chatbots, voice agents, and document understanding pipelines built on modern NLP."
        },
        {
            icons: BsGraphUp,
            title: "Predictive Analytics",
            description: "Turn your data into predictions, forecasts, and decision intelligence with custom ML models."
        },
        {
            icons: BsShieldCheck,
            title: "MLOps & Model Lifecycle",
            description: "CI/CD for models â€” evaluation, monitoring, drift detection, and continuous retraining."
        },
        {
            icons: BsClouds,
            title: "AI Cloud Infrastructure",
            description: "Vector databases, GPU endpoints, and managed AI pipelines on major cloud platforms."
        },
        {
            icons: BsCodeSlash,
            title: "AI-Powered Web & App",
            description: "Web and mobile products with AI features baked in from day one â€” not bolted on later."
        },

    ]

    const company = {
        name: "DGi WORX",
        url: "https://dgiworx.com.au/",
        logo: "https://dgiworx.com.au/assets/img/logo/dgilogo/dgi.png",
        contactType: "customer support",
        telephone: "+61 0436291143",
        areaServed: "AU",
        sameAs: [
            "https://www.facebook.com/dgiworx",
            "https://www.instagram.com/dgiworx/",
            "https://www.behance.net/dgiworx",
            "https://www.linkedin.com/company/67087770/"
        ]
    };

    // Services offered by the company
    const websiteservices = [
         {
            name: "Automation",
            type: "Automation services",
            description: "DGi WORX offers cutting-edge automation for streamlined processes, efficiency, and growth."
        },
         {
            name: "Migration Services",
            type: "Migration Services",
            description: "DGi WORX provide seamless web hosting migration with a customer-centric focus for business success."
        },
        {
            name: "Data Analytics",
            type: "Data Analytics services",
            description: "Our reporting dashboards provide insights for informed resource optimization, fueling growth."
        },
        {
            name: "Cloud Services",
            type: "Cloud services",
            description: "DGi WORX provides advanced cloud services for efficient data management, letting you focus on your core business."
        },
        {
            name: "NDIS",
            type: "NDIS services",
            description: "We specialize in NDIS web development, creating secure and user-friendly websites for plan management."
        },    
        {
            name: "Web Development",
            type: "Web development services",
            description: "DGi WORX delivers unwavering website development services, guaranteeing the utmost quality and reliability."
        },
        {
            name: "App Development",
            type: "Mobile development services",
            description: "Our mobile app development excels in meeting tight deadlines with customized solutions and advanced technology."
        },
        {
            name: "Ecommerce",
            type: "Ecommerce services",
            description: "DGi WORX tailors tech services for e-commerce, boosting sales, conversions, and fostering growth."
        },
        {
            name: "Design Works",
            type: "Design Works services",
            description: "Experience professional-grade designs from DGi WORX's graphic experts, expertly tailored to elevate your brand."
        },
        {
            name: "SEO",
            type: "SEO services",
            description: "DGi WORX, we understand the pivotal role that search engine optimization (SEO) plays in the success of your online presence."
        }
    ];

    const aiNativeServices = [
        { icon: BsCpu, bg: 'rgba(59,130,246,0.15)', color: '#3b82f6', title: 'LLM Fine-Tuning', desc: 'Training advanced models on your private corporate data for hyper-specific context and industry-leading privacy.' },
        { icon: RiRobot2Line, bg: 'rgba(249,115,22,0.15)', color: '#f97316', title: 'Autonomous Agents', desc: 'Designing AI agents that execute cross-platform tasks autonomously using state-of-the-art API integrations.' },
        { icon: BsShieldCheck, bg: 'rgba(34,197,94,0.15)', color: '#22c55e', title: 'Ethical AI Guardrails', desc: 'Ensuring compliance and security in AI adoption, especially for NDIS and sensitive enterprise environments.' },
    ];

    const ethos = [
        { icon: MdOutlineTrackChanges, title: 'OUR MISSION', desc: 'At DGi WORX, our mission is to revolutionise the digital landscape by crafting cutting-edge software solutions. We are dedicated to empowering businesses through innovation, driving growth, and enhancing user experiences.' },
        { icon: MdOutlineRemoveRedEye, title: 'OUR VISION', desc: 'Our vision is to be a global leader in digital innovation, where technology enriches and simplifies lives. We continually invest in research and development, forge strategic partnerships, and always prioritise our clients.' },
        { icon: MdOutlineHandshake, title: 'OUR VALUES', desc: 'Our guiding principles â€” innovation, integrity, customer-centricity, and excellence â€” shape our approach as an Australian software company. We uphold ethical standards, foster improvement, and prioritise client satisfaction.' },
    ];

    const schemaOrgJSONLD = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "Organization",
                "name": company.name,
                "url": company.url,
                "logo": company.logo,
                "contactPoint": {
                    "@type": "ContactPoint",
                    "contactType": company.contactType,
                    "telephone": company.telephone,
                    "areaServed": company.areaServed
                },
                "sameAs": company.sameAs
            },
            ...websiteservices.map(service => ({
                "@type": "Service",
                "name": service.name,
                "description": service.description,
                "provider": {
                    "@type": "Organization",
                    "name": company.name
                }
            }))
        ]
    };
    return (
        <div>
            <Helmet>

                <title>Top web design and software development company | DGI Worx</title>
                <meta name="description" content="Build modern websites and smart software with a creative web design and software development company, DGI Worx trusted by global clients." />
                <meta name="keywords" content="app development android, IT services Australia,
                companies for web development, DGi WORX, Cloud Services,
                Migration Services, ecommerce platforms, IoT, Dgiworx Australia, 
                best software development company, custom website, ecommerce website, 
                crm software, software maintainance, digital marketing company, technology training, 
                mobile app development, android app development, iOS app development" />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://dgiworx.com.au/" />
                <meta name="geo.country" content="Australia" />
                <meta name="geo.placename" content="Piara Waters, Western Australia" />
                <meta property="og:locale" content="en_au" />
                <meta property="og:title" content="Top web design and software development company | DGI Worx" />
                <meta property="og:description" content="Build modern websites and smart software with a creative web design and software development company, DGI Worx trusted by global clients." />
                <meta property="og:image" content="/assets/img/dgiworx-home-embedded.jpg" />
                <meta property="og:url" rel='canonical' content="https://dgiworx.com.au" />
                <script type="application/ld+json">
                    {JSON.stringify(schemaOrgJSONLD)}
                </script>
            </Helmet>
            {/* {isLoading ? (
                <Preloader />
            ) : ( */}
            <>

                {/* <!-- header-cart-end --> */}
                <main>

                    {/* <!-- baner-area-start --> */}
                    <section className="dgi-hero-section">
                        <div className="dgi-colorbends-bg">
                            <ColorBends
                                rotation={90}
                                speed={0.2}
                                colors={["#A855F7", "#3b82f6", "#020617"]}
                                transparent={false}
                                autoRotate={0}
                                scale={1}
                                frequency={1}
                                warpStrength={1}
                                mouseInfluence={1}
                                parallax={0.5}
                                noise={0.15}
                                iterations={1}
                                intensity={1.5}
                                bandWidth={6}
                            />
                        </div>
                        <div className="dgi-hero-overlay"></div>
                        <div className="dgi-hero-glow"></div>
                        <div className="dgi-hero-container">
                            <div className="dgi-hero-grid">
                                <div className="dgi-hero-left">
                                    <div className="dgi-partner-badge">
                                        <span className="dgi-partner-dot"></span>
                                        <span className="dgi-partner-text">Official AI Global Partner</span>
                                    </div>

                                    <div className="dgi-hero-headings">
                                        <p className="dgi-hero-eyebrow">Intelligent Enterprise Architecture</p>
                                        <h2 className="dgi-hero-title">
                                            WORLD CLASS <br />
                                            <TypeAnimation
                                                sequence={[
                                                    'AI SOLUTIONING', 3000,
                                                    'AI DEVELOPMENT', 2000,
                                                    'AI AUTOMATION', 2000,
                                                    'AI INNOVATION', 2000,
                                                ]}
                                                wrapper="span"
                                                typeSpeed={60}
                                                backSpeed={80}
                                                repeat={Infinity}
                                                className="dgi-gradient-text dgi-type-nowrap"
                                            />
                                        </h2>
                                        <p className="dgi-hero-para">
                                            Moving beyond simple development. We architect bespoke AI ecosystems, autonomous agents, and intelligence-powered infrastructures that redefine how modern businesses operate.
                                        </p>
                                    </div>

                                    <div className="dgi-hero-buttons">
                                        <a href="/contact" className="dgi-btn-primary">
                                            Start AI Transformation
                                            <AiOutlineArrowRight />
                                        </a>
                                        <a href="/artificialintelligence" className="dgi-btn-secondary">
                                            View AI Use Cases
                                        </a>
                                    </div>

                                    <div className="dgi-hero-stats">
                                        <div className="dgi-stat">
                                            <div className="dgi-stat-value">50+</div>
                                            <div className="dgi-stat-label">AI Models Deployed</div>
                                        </div>
                                        <div className="dgi-stat">
                                            <div className="dgi-stat-value">99%</div>
                                            <div className="dgi-stat-label">Inference Accuracy</div>
                                        </div>
                                        <div className="dgi-stat">
                                            <div className="dgi-stat-value">Next-Gen</div>
                                            <div className="dgi-stat-label">Enterprise Systems</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="dgi-hero-right">
                                    <div className="dgi-robot-wrap">
                                        <div className="dgi-robot-glow"></div>
                                        <div className="dgi-robot-ring dgi-robot-ring-1"></div>
                                        <div className="dgi-robot-ring dgi-robot-ring-2"></div>
                                        <img
                                            src="/assets/img/hero-roboto.png"
                                            alt="AI Robot Assistant"
                                            className="dgi-robot-img"
                                        />
                                        <div className="dgi-robot-badge dgi-robot-badge-top">
                                            <div className="dgi-robot-badge-dot"></div>
                                            <span>AI Online</span>
                                        </div>
                                        <div className="dgi-robot-badge dgi-robot-badge-bottom">
                                            <BsLightningChargeFill className="dgi-robot-badge-icon" />
                                            <span>24/7 Active</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {socialMediaLinks}
                        <div className="tp-banner-scroll-down">
                            <div className="tp-banner-scroll-shape">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="238" height="70.594" viewBox="0 0 238 70.594">
                                        <defs>
                                            <style>
                                                {`.cls-1 {
                                            fill: #fff;
                                            fill-rule: evenodd;
                                        }`}
                                            </style>
                                        </defs>
                                        <path id="scrolldown-shape-1.svg" className="cls-1" d="M847,980s40.865-5.656,69-43,81.412-36.188,103,0,66,43,66,43H847Z" transform="translate(-847 -909.406)"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div className="tp-banner-scroll-mouse">
                            <a href="#about">
                                <span>
                                    <svg id="scroll-down.svg" xmlns="http://www.w3.org/2000/svg" width="16" height="26" viewBox="0 0 16 26">
                                        <defs>
                                            <style>
                                                {`.cls-5,
                                            .cls-6 {
                                                fill: none;
                                            stroke: #131023;
                                            stroke-width: 1px;
                                             }

                                            .cls-6 {
                                                fill - rule: evenodd;
                                            }`}
                                            </style>
                                        </defs>
                                        <circle className="cls-5" cx="8.5" cy="7.5" r="2"></circle>
                                        <path className="cls-6" d="M963,922h5a5,5,0,0,1,5,5v15a5,5,0,0,1-5,5h-5a5,5,0,0,1-5-5V927A5,5,0,0,1,963,922Z" transform="translate(-957.5 -921.5)"></path>
                                    </svg>
                                </span>
                            </a>
                            <p>Scroll Down</p>
                        </div>
                        {/* <div className="tp-banner-video d-none d-md-block">
                            <a className="popup-video" href="#"><i><BsFillPlayFill className="flaticon-play" /></i></a>
                        </div> */}
                    </section>
                    {/* <!-- baner-area-end --> */}

                    

                    {/* <!-- AI Native Services --> */}
                    <section className="ai-native-section py-50">
                        <div className="container">
                            <div className="tp-section text-center mb-30">
                                <h2 className="ai-native-title">AI Native Services</h2>
                                <p className="ai-native-subtitle">Specialised intelligence for complex business challenges.</p>
                            </div>
                            <div className="ai-native-cards-row ">
                                {aiNativeServices.map((item, i) => (
                                    <div
                                        className={`ai-native-card${i < aiNativeServices.length - 1 ? ' ai-native-card--divider' : ''}`}
                                        key={i}
                                        style={{ animationDelay: `${i * 0.15}s` }}
                                    >
                                        <div className="ai-native-card__icon-wrap">
                                            <item.icon />
                                        </div>
                                        <h4 className="ai-native-card__title">{item.title}</h4>
                                        <p className="ai-native-card__desc">{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* <!-- AI Native Services end --> */}





                    {/* <!-- step-area-start --> */}
                    <section className="ops-process-section">
                        <div className="container">
                            {/* Header row */}
                            <div className="ops-process-header">
                                <div className="ops-process-header-left">
                                    {/* <span className="ops-process-badge">OUR PROCESS</span> */}
                                    <h2 className="ops-process-title">Operational Symphony</h2>
                                </div>
                                <div className="ops-process-header-right">
                                    <p className="ops-process-subtitle">A disciplined AI delivery process â€” from data audit to production MLOps â€” built for measurable enterprise outcomes.</p>
                                </div>
                            </div>

                            {/* Timeline numbers row */}
                            <div className="ops-timeline-row">
                                {[
                                    { num: '01', icon: BsSearch,         title: 'Discovery & Data Audit',     desc: 'Mapping your workflows, data estate, and AI readiness to surface the highest-impact use cases.' },
                                    { num: '02', icon: BsBrush,          title: 'AI Solution Design',         desc: 'Architecting the right blend of LLMs, agents, retrieval, and guardrails for your domain.' },
                                    { num: '03', icon: BsBracesAsterisk, title: 'Model Build & Integration',  desc: 'Fine-tuning models, building agentic pipelines, and wiring them into your existing stack.' },
                                    { num: '04', icon: BsEmojiLaughing,  title: 'Deploy & MLOps',             desc: 'Shipping to production with monitoring, evaluation, and continuous improvement loops.' },
                                ].map((step, i) => (
                                    <div className="ops-step-col" key={i}>
                                        <div className="ops-step-num-box">
                                            <span className="ops-step-num">{step.num}</span>
                                        </div>
                                        <h4 className="ops-step-title">{step.title}</h4>
                                        <p className="ops-step-desc">{step.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* <!-- step-area-end --> */}{/* <!-- AI Marquee Banner --> */}
                    {/* <div className="dgi-marquee-section" aria-hidden="true">
                        <div className="dgi-marquee-glow-left"></div>
                        <div className="dgi-marquee-glow-right"></div>
                        <div className="dgi-marquee-track-wrap">
                            <div className="dgi-marquee-track">
                                {[
                                    { text: 'AI Automation',      sym: 'âœ¦' },
                                    { text: 'LLM Fine-Tuning',    sym: 'â—ˆ' },
                                    { text: 'Autonomous Agents',  sym: 'âœ¦' },
                                    { text: 'AI Innovation',      sym: 'â—ˆ' },
                                    { text: 'Generative AI',      sym: 'âœ¦' },
                                    { text: 'Enterprise AI',      sym: 'â—ˆ' },
                                    { text: 'AI Security',        sym: 'âœ¦' },
                                    { text: 'Machine Learning',   sym: 'â—ˆ' },
                                    { text: 'AI Automation',      sym: 'âœ¦' },
                                    { text: 'LLM Fine-Tuning',    sym: 'â—ˆ' },
                                    { text: 'Autonomous Agents',  sym: 'âœ¦' },
                                    { text: 'AI Innovation',      sym: 'â—ˆ' },
                                    { text: 'Generative AI',      sym: 'âœ¦' },
                                    { text: 'Enterprise AI',      sym: 'â—ˆ' },
                                    { text: 'AI Security',        sym: 'âœ¦' },
                                    { text: 'Machine Learning',   sym: 'â—ˆ' },
                                ].map((item, i) => (
                                    <span className="dgi-marquee-item" key={i}>
                                        <span className="dgi-marquee-sym">{item.sym}</span>
                                        <span className="dgi-marquee-text">{item.text}</span>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div> */}
                    {/* <!-- AI Marquee Banner end --> */}

                    {/* <!-- about-area-start --> */}
                    <section id="about" className="about-area tp-about-two py-100">
                        <div className="container pt-20">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="dgi-home-about-collage wow fadeInRight" data-wow-duration="1s" data-wow-delay=".4s">
                                        <div className="dgi-home-about-accents" aria-hidden="true">
                                            <span className="dgi-home-about-accent-line dgi-home-about-accent-line--red"></span>
                                            <span className="dgi-home-about-accent-line dgi-home-about-accent-line--purple"></span>
                                        </div>
                                        <div className="dgi-home-about-card dgi-home-about-card--top">
                                            <img src="/assets/img/home/about-img1.jpg" alt="DGi WORX AI engineering team" loading="lazy" />
                                        </div>
                                        <div className="dgi-home-about-card dgi-home-about-card--bottom" style={{background:"transparent", boxShadow:"unset",border:"none"}}>
                                            <img src="/assets/img/home/about-img2.png" alt="AI-powered business solutions" loading="lazy" />
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="tp-about-two-wrapper mb-60 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".4s">
                                        <div className="tp-section mb-40">
                                            <span className="tp-section-sub-title">Inside DGi WORX: Your AI Transformation Partner</span>
                                            <h1 className="visually-hidden">Top web design and software development company</h1>
                                            <h2 className="visually-hidden">Top web design and software development company</h2>
                                            <h2 className="tp-section-title">Elevate Your Business with <br /> Production-Grade AI</h2>
                                            <div className="tp-section-title-wrapper">
                                                <p>DGi WORX is an AI engineering team that ships real systems â€” LLM apps, autonomous agents, RAG pipelines, and ML platforms â€” for enterprise customers across Australia, India, and the US. We pair deep technical craft with responsible AI practices, so your models are not just impressive demos but production assets that drive measurable business outcomes.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="tp-about-two-list">
                                            <ul>
                                                <li><span><img src="/assets/img/icon/check-list.png" alt="dgiworximg4" loading='lazy' /></span>AI Engineering Depth</li>
                                                <li><span><img src="/assets/img/icon/check-list.png" alt="dgiworximg5" loading='lazy' /></span>Production-Grade ML</li>
                                                <li><span><img src="/assets/img/icon/check-list.png" alt="dgiworximg6" loading='lazy' /></span>LLM &amp; Agent Specialists</li>
                                                <li><span><img src="/assets/img/icon/check-list.png" alt="dgiworximg7" loading='lazy' /></span>Responsible &amp; Ethical AI</li>
                                                <li><span><img src="/assets/img/icon/check-list.png" alt="dgiworximg8" loading='lazy' /></span>Domain-Aware Solutions</li>
                                                <li><span><img src="/assets/img/icon/check-list.png" alt="dgiworximg9" loading='lazy' /></span>Proven Enterprise Delivery</li>
                                            </ul>
                                        </div>
                                        <div className="tp-about-details d-flex align-items-center flex-wrap">
                                            <div className="tp-about-btn mr-30">
                                                <a className="tp-btn" href="/about">Discover More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tp-about-two-shape">
                            <div className="tp-about-two-shape-4">
                                <img src="/assets/img/about/two/about-2-shape-2.png" alt="dgiworximg10" loading='lazy' />
                            </div>
                        </div>

                    </section>
                    {/* <!-- about-area-end --> */}



                    <section className="brand-area py-50">
                        <div className="container-flu">
                            <Clientlogos item={Clientlogo} />
                            <Rightlogo item={Clientlogo2} />
                        </div>
                    </section>

                    {/* <!-- feature-area-start --> */}
                    <section className="feature-area ops-process-section py-50 p-relative">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-md-12">
                                    <div className="tp-section text-center mb-50">
                                        <span className="tp-section-sub-title">Built for Enterprise</span>
                                        <h2 className="tp-section-title text-light">AI Services That Ship</h2>
                                        <p className="text-light">From generative AI and autonomous agents to MLOps and AI-native infrastructure ” a full-stack AI capability set, delivered end-to-end.</p>
                                    </div>
                                </div>
                            </div>
                            <Boxcard item={service} />
                        </div>
                        <div className="tp-feature-shape">
                            <div className="tp-feature-shape-one w-img">
                                <img src="/assets/img/feature/one/features-bg.png" alt="dgiworximg16" loading="lazy" />
                            </div>
                        </div>
                    </section>
                    {/* <!-- feature-area-end --> */}


                    {/* <!-- project-area-start --> */}
                    <section id="project-id" className="prj-section">
                        {/* Section header */}
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8">
                                    <div className="tp-section text-center mb-50">
                                        <span className="tp-section-sub-title">Showcase of Our Recent Triumphs</span>
                                        <h4 className="tp-section-title">Check Our latest projects</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Desktop: expanding panel accordion */}
                        <div
                            className="prj-accordion"
                            onMouseLeave={() => setActivePanel(project[0].id)}
                        >
                            {project.map((proj) => (
                                <div
                                    key={proj.id}
                                    className={`prj-panel${activePanel === proj.id ? ' prj-panel--active' : ''}`}
                                    onMouseEnter={() => setActivePanel(proj.id)}
                                >
                                    <div
                                        className="prj-panel__bg"
                                        style={{ backgroundImage: `url(${proj.image})` }}
                                    />
                                    <div className="prj-panel__overlay" />

                                    {/* Collapsed: vertical rotated title */}
                                    <div className="prj-panel__collapsed">
                                        <span className="prj-panel__vtitle">{proj.title}</span>
                                        <span className="prj-panel__varrow">â†—</span>
                                    </div>

                                    {/* Expanded: content fade-in */}
                                    <div className="prj-panel__content">
                                        <span className="prj-panel__cat">{proj.category}</span>
                                        <h3 className="prj-panel__title">{proj.title}</h3>
                                        <a
                                            href={proj.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="prj-panel__btn"
                                            aria-label={`View ${proj.title}`}
                                        >
                                            <AiOutlineArrowRight />
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Mobile: simple image grid */}
                        <div className="prj-mobile-grid container">
                            <div className="row">
                                {project.map((proj) => (
                                    <div className="col-12 prj-mob-item" key={proj.id}>
                                        <a
                                            href={proj.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="prj-mobile-card"
                                        >
                                            <img src={proj.image} alt={proj.title} loading="lazy" />
                                            <div className="prj-mobile-card__info">
                                                <span>{proj.category}</span>
                                                <h4>{proj.title}</h4>
                                            </div>
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* <!-- project-area-end --> */}





                    {/* <!-- testimonial-area-start --> */}
                    <section className="testimonial-area tp-testimonial-inner  py-50">
                        <div className="container">
                            <Testimonial />
                            <div className="row">

                            </div>
                        </div>
                    </section>
                    {/* <!-- testimonial-area-end --> */}



                    {/* <!-- services-area-start --> */}
                    <section className="services-area dgi-services-vanta tp-services-plr dgi-back-area parallex-image mt-30 py-100">
                        <div className="dgi-services-vanta-bg" aria-hidden="true">
                            <SoftAurora
                                speed={0.6}
                                scale={1.5}
                                brightness={1}
                                color1="#e00b0b"
                                color2="#f2eff4"
                                noiseFrequency={2.5}
                                noiseAmplitude={1}
                                bandHeight={0.5}
                                bandSpread={1}
                                octaveDecay={0.1}
                                layerOffset={0}
                                colorSpeed={1}
                                enableMouseInteraction
                                mouseInfluence={0.25}
                            />
                        </div>
                        <div className="container-fluid tp-services-width">
                            <div className="row">
                                <div className="col-xl-4 col-lg-6">
                                    <div className="tp-services-item d-flex mb-30 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".4s">
                                        <div className="tp-services-item-head">
                                            <span>D</span>
                                        </div>
                                        <div className="tp-services-item-thumb">
                                            <img src="/assets/img/services/one/1.jpg" alt="dgiworximg17" loading="lazy" />
                                        </div>
                                        <div className="tp-services-item-content">
                                            <h4 className="tp-services-item-title">Data-Driven<br />Intelligence</h4>
                                            <p>We turn your data into models, agents, and decisions that compound in value over time.</p>
                                        </div>
                                        <div className="tp-services-item-shape">
                                            <img src="/assets/img/services/one/shape/shape-01.png" alt="dgiworximg18" loading="lazy" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-6">
                                    <div className="tp-services-item d-flex mb-30 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".4s">
                                        <div className="tp-services-item-thumb">
                                            <img src="/assets/img/services/one/2.jpg" alt="dgiworximg19" loading="lazy" />
                                        </div>
                                        <div className="tp-services-item-content">
                                            <h4 className="tp-services-item-title">Generative AI at Scale<br /></h4>
                                            <p>Production LLM systems with the evaluation, observability, and guardrails enterprises need.</p>
                                        </div>
                                        <h3 className="visually-hidden">Top web design and software development company</h3>
                                        <div className="tp-services-item-head">
                                            <span>G</span>
                                        </div>
                                        <div className="tp-services-item-shape">
                                            <img src="/assets/img/services/one/shape/shape-01.png" alt="dgiworximg20" loading="lazy" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-6">
                                    <div className="tp-services-item d-flex mb-30 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".4s">
                                        <div className="tp-services-item-thumb">
                                            <img src="/assets/img/services/one/3.jpg" alt="dgiworximg21" loading="lazy" />
                                        </div>
                                        <div className="tp-services-item-content">
                                            <h4 className="tp-services-item-title">Intelligent Automation</h4>
                                            <p>Agentic workflows that take real work off your team's plate, every single productive day.</p>
                                        </div>
                                        <div className="tp-services-item-head">
                                            <span>i</span>
                                        </div>
                                        <div className="tp-services-item-shape">
                                            <img src="/assets/img/services/one/shape/shape-01.png" alt="dgiworximg22" loading="lazy" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!-- services-area-end --> */}



                    {/* <!-- brand-area-start --> */}
                    {/* <section className="brand-area py-50">
                        <div className="container-flu">
                            <Clientlogos item={Clientlogo} />
                            <Rightlogo item={Clientlogo2}/>
                        </div>
                    </section> */}
                    {/* <!-- brand-area-end --> */}



                    {/* <!-- blog-area-start --> */}
                    {/* <section className="blog-area pt-150 pb-100">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="tp-section text-center mb-60">
                                        <span className="tp-section-sub-title">Our Latest Update</span>
                                        <h4 className="tp-section-title">Read Our Latest News</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="tp-blog-wrapper">
                                <div className="row gx-0">
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="tp-blog-item text-center">
                                            <div className="tp-blog-item-thumb tp-thumb-common fix overlay-anim mb-20">
                                                <div className="tp-thumb-common-overlay wow"></div>
                                                <a href="blog-details.html.htm">
                                                    <img src="/assets/img/blog/one/blog-thumb-1.jpg" alt="" loading="lazy" />
                                                </a>
                                            </div>
                                            <div className="tp-blog-item-content">
                                                <div className="tp-blog-item-tag mb-20">
                                                    <a href="blog-details.html.htm">BRAND</a>
                                                    <a href="blog-details.html.htm">SOLUTION</a>
                                                </div>
                                                <h4 className="tp-blog-item-title mb-30">
                                                    <a href="blog-details.html.htm">How to Create an <br /> Awesome Website</a>
                                                </h4>
                                                <div className="tp-blog-item-btn">
                                                    <a href="blog-details.html.htm">Read More</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="tp-blog-item text-center">
                                            <div className="tp-blog-item-thumb tp-thumb-common fix overlay-anim mb-20">
                                                <div className="tp-thumb-common-overlay wow"></div>
                                                <a href="blog-details.html.htm">
                                                    <img src="/assets/img/blog/one/blog-thumb-2.jpg" alt="" loading="lazy" />
                                                </a>
                                            </div>
                                            <div className="tp-blog-item-content">
                                                <div className="tp-blog-item-tag mb-20">
                                                    <a href="blog-details.html.htm">BRAND</a>
                                                    <a href="blog-details.html.htm">SOLUTION</a>
                                                </div>
                                                <h4 className="tp-blog-item-title mb-30">
                                                    <a href="blog-details.html.htm">What is Holding Back <br /> The IT Solution</a>
                                                </h4>
                                                <div className="tp-blog-item-btn">
                                                    <a href="blog-details.html.htm">Read More</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="tp-blog-item tp-blog-item-last text-center">
                                            <div className="tp-blog-item-thumb tp-thumb-common fix overlay-anim mb-20">
                                                <div className="tp-thumb-common-overlay wow"></div>
                                                <a href="blog-details.html.htm">
                                                    <img src="/assets/img/blog/one/blog-thumb-3.jpg" alt="" loading="lazy" />
                                                </a>
                                            </div>
                                            <div className="tp-blog-item-content">
                                                <div className="tp-blog-item-tag mb-20">
                                                    <a href="blog-details.html.htm">BRAND</a>
                                                    <a href="blog-details.html.htm">SOLUTION</a>
                                                </div>
                                                <h4 className="tp-blog-item-title mb-30">
                                                    <a href="blog-details.html.htm">Easy to Use Software <br /> New Ennovation</a>
                                                </h4>
                                                <div className="tp-blog-item-btn">
                                                    <a href="blog-details.html.htm">Read More</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> */}
                    {/* <!-- blog-area-end --> */}

                    {/* <Componcontact /> */}
                </main>

            </>
            {/* )} */}
        </div>
    );
};

export default Home;